import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';
import chevronGreyIcon from 'assets/images/icons/chevron-grey.svg';
import plusGreenIcon from 'assets/images/icons/plus.svg';
import { generateTextWithSuffix } from 'components/utils';
import TextField from 'components/form-components/TextField';
import AddTaskLabelModal from '../AddTaskLabelModal';

const AdvanceTab = ({ values, setValues, labelOptions }) => {
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [showLabelAddModal, setShowLabelAddModal] = useState(false);
  const [labelOptionsList, setLabelOptionsList] = useState([]);

  useEffect(() => {
    if (labelOptions.length) setLabelOptionsList(labelOptions);
  }, [labelOptions]);

  const handleChange = (field, value) => {
    setValues((prevValues) => {
      const updatedValues = { ...prevValues };
      updatedValues[field] = value;
      return updatedValues;
    });

    setTouched((prevTouched) => ({ ...prevTouched, [field]: true }));
    setErrors((prevErrors) => ({ ...prevErrors, [field]: undefined }));
  };

  return (
    <>
      <div className='d-flex flex-column gap-3'>
        <div className='d-flex flex-column gap-2'>
          <MultiLevelSelect
            options={{ children: labelOptionsList, selectMultiple: true, searchable: true }}
            value={values.labels}
            name={'labels'}
            displayName={'field_label'}
            handleChange={handleChange}
            align='end'
            classes='theme-font-jakartaSans-regular'
            toggleClasses='theme-height-44 d-flex justify-content-between align-items-center px-2 py-1 border-grey-1-h-1 rounded-sm cursor-pointer'
            toggleComponent={
              <>
                <label className='cursor-pointer'>
                  {generateTextWithSuffix(
                    values.labels
                      .map((id) => labelOptionsList.find((o) => o.value === id)?.displayValue)
                      .filter(Boolean),
                    2,
                    (count) => ` +${count} more`,
                    'select_select',
                    t,
                  )}
                </label>
                <img className='rotate-180' src={chevronGreyIcon} />
              </>
            }
          />

          <div className='d-flex align-items-center gap-2'>
            <img src={plusGreenIcon} />
            <label
              className='theme-text-green-1 cursor-pointer'
              onClick={() => setShowLabelAddModal(true)}
            >
              {t('text_add_label')}
            </label>
          </div>
        </div>

        <TextField
          name={'location'}
          value={values.location}
          displayName={'field_location'}
          placeholder={'field_placeholder_enter_coordinates'}
          handleChange={handleChange}
          shrinkFieldOnly
          classes='w-100'
          error={errors['location']}
          touched={touched['location']}
        />
      </div>

      <AddTaskLabelModal
        show={showLabelAddModal}
        closeModal={() => setShowLabelAddModal(false)}
        getUpdatedOptions={(v) => setLabelOptionsList(v)}
      />
    </>
  );
};

AdvanceTab.propTypes = {
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  labelOptions: PropTypes.array.isRequired,
};

export default AdvanceTab;
